export const config = {
    IDENTITY_URL: process.env.REACT_APP_IDENTITY_URL,
    OASIS_PORTAL_URL: process.env.REACT_APP_OASIS_PORTAL_URL
}